import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"

import { Link } from "react-router-dom"

// components
import Applications from "pages/Dashboard/applications"

// services
import ApplicationService from "../../services/applications/Application.service"
import Staff from "services/staff/Staff"
import ApplicationFilter from "components/Filter/ApplicationFilter"
import CompanyService from "services/applications/Company.service"
import { useLocation } from 'react-router-dom';


let newCompanyService = null
let appService = null
let plasticsUser = null
let staffService = new Staff()

const CompanyApplications = () => {
  const [menu, setMenu] = useState(false)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [permissions, setpermissions] = useState()
  const [allApplications, setallApplications] = useState()

const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');



  const [searchMode, setsearchMode] = useState(false)
  const [filterValues, setFilterValues] = useState({
    search: "",
    application_status: "",
    date_from: "",
    date_to: "",
    company_id:"",
  })

  const toggle = () => {
    setMenu(!menu)
  }

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    newCompanyService = new CompanyService(userObj)
    appService = new ApplicationService(userObj)

    setuser(userObj)
    newCompanyService.getCompanyCompanies(0,id).then(response => {
      if (response.status) {
        setallApplications(response.data)
        console.log(allApplications)
        setmounted(true)
      }
    })
  }, [])

  const paginate = page => {
    // If we are in search mode, we will call the search endpoint instead
    if (searchMode) {
      newCompanyService.searchApplications(filterValues, page).then(response => {
        setallApplications(response.data)
      })
    } else {
      newCompanyService.getCompanyCompanies(page,id).then(response => {
        if (response.status) {
          setallApplications(response.data)
        }
      })
    }
    
  }

  const initiateSearch = (data) => {
    console.log(data)
    setsearchMode(true)
    setFilterValues(data)
    appService.searchApplications(data, null).then(response => {
      setallApplications(response.data)
    })
  }

  const turnOffSearchMode = () => {
    setsearchMode(false)
    paginate(0)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Company Applications</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">All Applications</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                  </li>
                </ol>
              </Col>
            </Row>
          </div>

          {mounted ? (
            <Row>
              <ApplicationFilter handleSearch={initiateSearch} turnOffSearch={turnOffSearchMode} company_id={id} />
              <Applications
                viewOnly={true}
                user={user}
                data={allApplications}
                paginate={paginate}
              />
            </Row>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CompanyApplications
